import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import {
  getDatabase,
  ref,
  set,
  get,
  push,
  child,
  onValue,
  update,
  remove,
  query,
  orderByChild,
  equalTo,
} from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC3zSoLUaTech4efVhUqEP7VVvSYtnJj9s",
  authDomain: "aerovolt-db464.firebaseapp.com",
  databaseURL: "https://aerovolt-db464-default-rtdb.firebaseio.com",
  projectId: "aerovolt-db464",
  storageBucket: "aerovolt-db464.firebasestorage.app",
  messagingSenderId: "970636161284",
  appId: "1:970636161284:web:a6055cefb52561cf3ce051",
  measurementId: "G-RL9767BD37",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);

export {
  database,
  auth,
  ref,
  set,
  get,
  push,
  child,
  onValue,
  update,
  remove,
  query,
  orderByChild,
  equalTo,
};